import React from 'react';
import { Button } from '@material-ui/core';
import { ButtonDiv, PreviewFormDiv } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

type PreviewFormProps = {
  onOKPreviewClick?: () => void;
  onCancelPreviewClick?: () => void;
  okDisabled?: boolean;
};

export const PreviewForm = ({
  onOKPreviewClick,
  onCancelPreviewClick,
  okDisabled,
}: PreviewFormProps) => (
  <PreviewFormDiv id="preview-form">
    {defaults.changesOK}
    <ButtonDiv>
      <Button
        title="OK"
        size="small"
        variant="contained"
        color="primary"
        disabled={okDisabled}
        onClick={onOKPreviewClick}
      >
        {defaults.acceptChanges}
      </Button>
      <Button
        title="Cancel"
        size="small"
        variant="contained"
        color="primary"
        onClick={onCancelPreviewClick}
      >
        {defaults.discardChanges}
      </Button>
    </ButtonDiv>
  </PreviewFormDiv>
);
export default PreviewForm;
